import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=9033cf16&scoped=true"
import script from "./Workplace.vue?vue&type=script&lang=js"
export * from "./Workplace.vue?vue&type=script&lang=js"
import style0 from "./Workplace.vue?vue&type=style&index=0&id=9033cf16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9033cf16",
  null
  
)

export default component.exports